import $ from 'jquery';

const InternationalModal = {
  init: () => {
    $(function () {
      const storageKey = '@setpar:internationalModalVisualized';
      const elementId = '#international-modal';

      // show modal if the country is not Brazil and the user did not see the modal
      if (window.options.should_show_internacional_modal) {
        var visualized = window.localStorage.getItem(storageKey);
        if (!visualized) {
          setTimeout(() => {
            $(elementId).modal('show');
          }, 5000);

          $(elementId).on('hide.bs.modal', function () {
            // save view in localStorage
            window.localStorage.setItem(storageKey, true);
          });
        }
      }

      // show modal if url parameters have modal-internacional
      if (
        window.options.should_show_internacional_modal &&
        window.location.search.includes('?modal-internacional')
      ) {
        $(elementId).modal('show');
      }
    });
  },
};

export default InternationalModal;
